import { TENANT_AUTH } from './authMode';

let API_BASE_URL = "";

if (TENANT_AUTH) {
  // Production builds must explicitly select their API; DEV keeps loopback.
  if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_API_BASE_URL) {
    throw new Error('REACT_APP_API_BASE_URL is required for a production tenant login build.');
  }
  API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
} else if (window.location.hostname === "localhost") {
  // Lokale Entwicklung
  API_BASE_URL = "http://localhost:5000";
} else {
  // Produktion auf dem VPS
  API_BASE_URL = "https://jvapi.koque.de";
}

export default API_BASE_URL;
